
import { defineComponent } from "vue";

export default defineComponent({
  name: "step-5",
  components: {}
});
